export enum EEmoji {
  POSITIVE = '😊',
  NEUTRAL = '😐',
  NEGATIVE = '😡',
}
